import { InvoiceUser } from "../../../services/Invoices/InvoiceService/InvoiceService";
import { IInvoiceUserList } from "./types";

export const mapInvoiceUserList = (data: InvoiceUser[]): IInvoiceUserList[] => {
	return data.map((item) => ({
		key: `${item.id}`,
		id: item.id,
		registerEmail: item.registerEmail,
		businessName: item.businessName,
		businessEmail: item.businessEmail,
		roleName: item.roleName,
		creatorProfileCreated: item.creatorProfileCreated,
		createdDate: item.createdDate
	}));
};

export const IndianformatDate = (dateString: string) => {
	const date = new Date(dateString);
	return date.toLocaleDateString("en-GB", {
		day: "2-digit",
		month: "short",
		year: "numeric"
	});
};
